import React from 'react';
import { useSelector } from 'react-redux';
import { AgCharts } from 'ag-charts-react';
import 'ag-charts-enterprise';

const DataChart = ({ dataForPlotting, selectedPlotNames, showComparison }) => {
    const { CategoryProductsPlotDropdown } = useSelector(state => state.form || {});

    const upperCaseName = CategoryProductsPlotDropdown ? CategoryProductsPlotDropdown.charAt(0).toUpperCase() + CategoryProductsPlotDropdown.slice(1) : ``;
    const currentName = selectedPlotNames.find(item => item.value === CategoryProductsPlotDropdown);

    const renderer = (params) => {
        const types = params.datum[CategoryProductsPlotDropdown];
        return (
            `<div class="ag-chart-tooltip-custom"><b class="title">${params.datum.categoryName}</b><br/><b>${upperCaseName}: ${types}</b></div>`
        );
    };

    const rendererCompare = (params) => {
        const types = params.datum[CategoryProductsPlotDropdown];
        const compareValue = params.datum[`compare${upperCaseName}`];
        return (
            `<div class="ag-chart-tooltip-custom"><b class="title">${params.datum.categoryName}</b><br/><b>${`Compare ${CategoryProductsPlotDropdown}`}: ${compareValue}<br/>${upperCaseName}: ${types}</b></div>`
        );
    };

    const chartOptions = {
        data: dataForPlotting,
        series: [
            {
                type: 'bar',
                xKey: 'categoryName',       // X-axis key (the dates)
                yKey: CategoryProductsPlotDropdown,      // Y-axis key (sales)
                yName: upperCaseName,
                fill: '#5f4bb3',
                tooltip: { renderer },
            }
        ],
        axes: [
          {
            type: 'category',  // X-axis is a category axis for the date
            position: 'bottom',
            title: {
                text: currentName ? currentName : ``,
            },
          },
          {
            type: 'number',    // Y-axis is a number axis for sales
            position: 'left',
          },
        ],
        background: {
            fill: '#f8f9fa', // Set background color here
        },
    };

    const compareBar = {
        // Compare Bar
      type: 'bar',
      xKey: 'categoryName',       // X-axis key (the dates)
      yKey: `compare${upperCaseName}`,      // Y-axis key (sales)
      yName: `Compare ${upperCaseName}`,
      fill: '#ff9b31',
      tooltip: { renderer: rendererCompare },
    };

    if (showComparison) chartOptions.series.unshift(compareBar);    

    return(
        <div style={{ height: 450 }}>
            <AgCharts options={chartOptions} style={{ height: 450 }}/>
        </div>
    )};
export default DataChart;